import device_type from "@/assets/data/device/device_type";

const deviceComp = () => import("@/views/omp/device/device.vue");

const deviceRoutes = device_type.map((item) => {
    const route = {
        path: `${item.key}`,
        name: `dev-device-${item.key}`,
        component: deviceComp,
        meta: {
            title: item.name,
            icon: `dev-device-${item.key}`,
            typeId: item.id,
        },
    };
    return route;
});

export default [
    {
        path: "/dev",
        name: "dev__root__",
        redirect: {
            name: "dev-index",
        },
        component: () => import("@/layouts/default.vue"),
        meta: {
            parent: "dev",
            title: "",
        },
        children: [
            {
                path: "index",
                name: "dev-index",
                component: () => import("@/views/dev/index.vue"),
                meta: {
                    title: "控制面板",
                    icon: "index",
                    affix: true,
                },
            },
        ],
    },
    {
        path: "/dev/conf",
        name: "dev-conf",
        meta: {
            title: "基础配置",
            icon: "dev-conf",
            parent: "dev",
            group: 512,
        },
        component: () => import("@/layouts/default.vue"),
        redirect: "/dev/conf/global",
        children: [
            {
                path: "global",
                name: "dev-conf-global",
                component: () => import("@/views/dev/conf/index"),
                meta: {
                    title: "全局配置",
                    icon: "all-setting",
                    affix: false,
                },
            },
            {
                path: "static",
                name: "dev-conf-static",
                component: () => import("@/views/dev/conf/static"),
                meta: {
                    title: "静态配置",
                    icon: "dev-conf-static",
                    affix: false,
                },
            },
            {
                path: "timezoneconf",
                name: "dev-timezoneconf",
                component: () => import("@/views/omp/titan/timezone"),
                meta: {
                    title: "时区配置",
                    icon: "dev-timezone-conf",
                    affix: false,
                },
            },
            {
                path: "permission",
                name: "dev-permission",
                component: () => import("@/views/omp/titan/permission"),
                meta: {
                    title: "权限配置",
                    icon: "dev-permission",
                    affix: false,
                },
            },
            {
                path: "super",
                name: "dev-account-super",
                component: () => import("@/views/omp/account/super.vue"),
                meta: {
                    title: "开发者身份",
                    icon: "dev-account-super",
                },
            },

            {
                path: "email",
                name: "mstplEmail",
                component: () => import("@/views/cms/mstpl/email.vue"),
                meta: {
                    title: "邮件模板",
                    icon: "cms-template-email",
                    affix: false,
                },
            },
            {
                path: "email-detail/:slug([\\w_-]+)?",
                name: "mstplEmailDetail",
                hidden: true,
                component: () => import("@/views/cms/mstpl/email/detail.vue"),
                meta: {
                    title: "邮件模板详情",
                    affix: false,
                    activeMenu: "/dev/conf/email",
                },
            },
        ],
    },
    {
        path: "/dev/sensor",
        name: "dev-sensor",
        meta: {
            title: "业务配置",
            icon: "dev-sensor",
            parent: "dev",
            permission: "manage_titan_config",
        },
        component: () => import("@/layouts/default.vue"),
        redirect: "/dev/sensor/preset",
        children: [
            {
                path: "nodetemplate",
                name: "nodetemplate",
                component: () => import("@/views/omp/sensor/nodetemplate"),
                meta: {
                    title: "节点模板",
                    icon: "dev-node-template",
                    affix: false,
                },
            },
            {
                path: "parameter-template",
                name: "parameter-template",
                component: () => import("@/views/omp/sensor/parameter-template"),
                meta: {
                    title: "读数模板",
                    icon: "dev-node-template",
                    affix: false,
                },
            },
            {
                path: "irrigation",
                name: "irrigation",
                component: () => import("@/views/dev/titan/irrigation"),
                meta: {
                    title: "灌溉配置",
                    icon: "dev-irrigation",
                    affix: false,
                },
            },
            {
                path: "preset",
                name: "preset",
                component: () => import("@/views/omp/sensor/preset/index.vue"),
                meta: {
                    title: "属性预设",
                    icon: "dev-preset",
                    affix: false,
                },
            },
            {
                path: "codesnippet",
                name: "codesnippet",
                component: () => import("@/views/omp/sensor/codesnippet"),
                meta: {
                    title: "代码片段",
                    icon: "dev-code-snippet",
                    affix: false,
                },
            },
            {
                path: "crontask",
                name: "crontask",
                component: () => import("@/views/omp/sensor/crontask"),
                meta: {
                    title: "定时任务",
                    icon: "dev-cron-task",
                    affix: false,
                },
            },
            {
                path: "indicator",
                name: "indicator",
                component: () => import("@/views/omp/sensor/indicator"),
                meta: {
                    title: "环境指标",
                    icon: "dev-indicator",
                    affix: false,
                },
            },
            {
                path: "control",
                name: "control",
                component: () => import("@/views/omp/control/index.vue"),
                meta: {
                    title: "自动控制",
                    icon: "dev-control",
                    affix: false,
                },
            },
            {
                path: "fertilizer",
                name: "fertilizer",
                component: () => import("@/views/dev/titan/fertilizer.vue"),
                meta: {
                    title: "肥料配置",
                    icon: "dev-fertilizer",
                    affix: false,
                },
            },
        ],
    },
    {
        path: "/dev/resource",
        name: "dev-resource",
        meta: {
            title: "资源管理",
            icon: "cms-resource",
            parent: "dev",
            permission: "manage_titan_config",
        },
        component: () => import("@/layouts/default.vue"),
        redirect: "/dev/resource/group",
        children: [
            {
                path: "version",
                name: "dev-device-version",
                component: () => import("@/views/omp/device/version.vue"),
                meta: {
                    title: "加密版本",
                    icon: "dev-device-version",
                },
            },
            {
                path: "device",
                name: "dev-inventory-device",
                component: () => import("@/views/fms/device"),
                meta: {
                    title: "设备库存",
                    icon: "prod-inventory-device",
                    affix: false,
                },
            },
        ],
    },
    {
        path: "/dev/device",
        name: "dev-device",
        meta: {
            title: "设备管理",
            icon: "dev-device",
            parent: "dev",
            permission: "manage_device",
        },
        component: () => import("@/layouts/default.vue"),
        redirect: {
            name: "dev-device-list",
        },
        children: [
            {
                path: "list",
                name: "dev-device-list",
                component: () => import("@/views/omp/device/index.vue"),
                meta: {
                    title: "全部设备",
                    icon: "dev-device-all",
                },
            },
        ].concat(deviceRoutes),
    },
    {
        path: "/dev/task",
        name: "task",
        meta: {
            title: "任务管理",
            icon: "dev-todo",
            parent: "dev",
            permission: "manage_system",
        },
        component: () => import("@/layouts/default.vue"),
        redirect: "/dev/task/aigrow",
        children: [
            {
                path: "aigrow",
                name: "ripen-task-replay",
                component: () => import("@/views/omp/aigrow/task"),
                // hidden: true,
                meta: {
                    title: "果熟识别",
                    icon: "dev-aigrow",
                    affix: false,
                },
            },
        ],
    },
    {
        path: "/dev/pm",
        name: "dev-pm",
        meta: {
            title: "项目管理",
            icon: "pm",
            parent: "dev",
            permission: "manage_system",
        },
        component: () => import("@/layouts/default.vue"),
        redirect: "/dev/pm/i18n",
        children: [
            {
                path: "i18n",
                name: "dev-pm-i18n",
                component: () => import("@/views/dev/pm/i18n.vue"),
                meta: {
                    title: "国际化",
                    icon: "i18n",
                },
            },
            {
                path: "i18n-form/:id(\\d+)?",
                name: "dev-pm-i18n-form",
                hidden: true,
                component: () => import("@/views/dev/pm/i18n-form.vue"),
                meta: {
                    title: "国际化",
                    affix: false,
                    activeMenu: "/dev/pm/i18n",
                },
            },
            {
                path: "i18n-detail/:id(\\d+)?",
                name: "dev-pm-i18n-detail",
                hidden: true,
                component: () => import("@/views/dev/pm/i18n-detail.vue"),
                meta: {
                    title: "国际化详情",
                    affix: false,
                    activeMenu: "/dev/pm/i18n",
                },
            },
            {
                path: "deploy",
                name: "dev-system-deploy",
                component: () => import("@/views/dev/system/deploy.vue"),
                meta: {
                    title: "前端部署",
                    icon: "dev-system-deploy",
                    affix: false,
                },
            },
        ],
    },
    {
        path: "/dev/system",
        name: "dev-system",
        meta: {
            title: "系统管理",
            icon: "all-system",
            parent: "dev",
            permission: "manage_system",
        },
        component: () => import("@/layouts/default.vue"),
        redirect: {
            name: "dev-system-app",
        },
        children: [
            {
                path: "cache",
                name: "dev-system-cache",
                component: () => import("@/views/dev/system/cache.vue"),
                meta: {
                    title: "缓存管理",
                    icon: "dev-system-cache",
                    affix: false,
                },
            },
            {
                path: "cdn",
                name: "dev-system-cdn",
                component: () => import("@/views/dev/system/cdn.vue"),
                meta: {
                    title: "内容分发",
                    icon: "dev-system-cdn",
                    affix: false,
                },
            },
            {
                path: "app",
                name: "dev-system-app",
                component: () => import("@/views/dev/system/app/index.vue"),
                meta: {
                    title: "应用管理",
                    icon: "dev-system-app",
                    affix: false,
                },
            },
            {
                path: "service-log",
                name: "dev-service-log",
                component: () => import("@/views/dev/system/service_log/index.vue"),
                meta: {
                    title: "后端日志",
                    icon: "dev-service-log",
                },
            },
        ],
    },
];
